import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const validationSchema = () =>
  createValidationSchema({
    serviceType: commonValidationSchemas.string({ required: true }),
    billingType: commonValidationSchemas.string({ required: true }),
    description: commonValidationSchemas.string({ required: true }),
    name: commonValidationSchemas.string({}),
    price: commonValidationSchemas.number({ min: 0 }).when('status', {
      is: true,
      then: (s) => s.min(1).required(),
    }),
    status: commonValidationSchemas.boolean(),
  });
